import React, { Component } from 'react'
import { func, array } from 'prop-types'
import { Box, Flex } from 'grid-styled'
import Hide from '../../../styles/utilities/Hide'
// Components
import DropdownList from './DropdownList'
import Dropdown from './Dropdown'
import DotButton from 'app/elements/DotButton'
// import Checkbox from 'app/elements/Checkbox'
import IdentifiersListItem from '../../elements/IdentifiersListItem'
// Styles
import { ListContainer, ListItem, DropdownBox } from './styles'
import { blueGray } from 'styles/settings/colors'

export default class IdentifiersList extends Component {
  static propTypes = {
    identifiers: array.isRequired,
    checkboxValues: array.isRequired,
    handleSelectItem: func.isRequired,
    handleSelectAll: func.isRequired,
    handleLoadMoreItems: func.isRequired
  }
  static defaultProps = {
    identifiers: [],
    checkboxValues: [],
    handleSelectItem: () => {},
    handleSelectAll: () => {},
    handleIncreaseList: () => {}
  }

  constructor(props) {
    super(props)
    this.state = {
      isItemDropdownOpen: null,
      itemDropdownId: null,
      isDropdownOpen: false,
      veloeTagsOptions: ['Ativa', 'Bloqueada'],
      selectedOption: 'Ativa',
      identificadores: props.identifiers || []
    }
    window.onscroll = () => {
      if (
        document.getElementById('footer') &&
        window.innerHeight +
          document.documentElement.scrollTop +
          document.getElementById('footer').offsetHeight >=
          document.documentElement.offsetHeight
      ) {
        props.handleLoadMoreItems()
      }
    }
  }

  componentDidMount() {
    this.setState({ identificadores: this.props.identifiers })
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { identifiers } = this.props
    if (prevProps.identifiers !== identifiers && identifiers.length > 0) {
      this.setState({ identificadores: this.props.identifiers })
    }
  }

  handleDropdown = () => {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen })
  }

  handleItemDropdown = itemDropdownId => () => {
    if (itemDropdownId) {
      return this.setState({ isItemDropdownOpen: true, itemDropdownId })
    }
    this.setState({ isItemDropdownOpen: false, itemDropdownId: null })
  }

  handleSelectOption = selectedOption => {
    this.setState({ selectedOption, isDropdownOpen: false })
  }

  changeTagIdentifiers = identifier => {
    const identifiers = this.state.identificadores.map(
      item => (item.codIdentificador === identifier.codIdentificadore ? identifier : item)
    )

    this.setState({ identificadores: identifiers })
  }

  render() {
    const {
      checkboxValues,
      handleSelectItem,
      // handleSelectAll,
      handleCreateInf,
      isPartner,
      idConta
    } = this.props
    const { isDropdownOpen, veloeTagsOptions, selectedOption, identificadores } = this.state
    const itemStatus = selectedOption === 'Bloqueada' ? 'INATIVO' : 'ATIVO'
    // const isAllChecked = checkboxValues.length === identifiers.length

    const identifiersFiltered = identificadores.filter(({ situacao }) => situacao === itemStatus)
    return (
      identifiersFiltered && (
        <ListContainer>
          <ListItem>
            <Flex width={1} direction={['column', 'row']}>
              {/* <Box width={[1 / 12, 0.5 / 12]}>
                <Checkbox onChange={handleSelectAll} checked={isAllChecked} />
              </Box> */}
              <Box width={[3 / 12, 2 / 12]}>veículo</Box>
              <Box width={[3 / 12, 2 / 12]}>placa</Box>
              <Hide at="small" width={[1, 2 / 12]}>
                eixos
              </Hide>
              <DropdownBox width={[3 / 12, 2 / 12]}>
                <Dropdown
                  isOpen={isDropdownOpen}
                  categoryLabel="VeloeTag"
                  dropdownLabel={selectedOption}
                  onClick={this.handleDropdown}
                />
                <DropdownList
                  optionSelected={selectedOption}
                  options={veloeTagsOptions}
                  isOpen={isDropdownOpen}
                  onClose={this.handleDropdown}
                  onSelect={this.handleSelectOption}
                />
              </DropdownBox>
              <Box width={[3 / 12, 3 / 12]}>Informações gerenciais</Box>
              {isPartner && <Box width={[3 / 12, 2 / 12]}>Ponto a Ponto</Box>}
              <Box width={[1, 0.5 / 12]}>
                <DotButton color={blueGray} removeCursor />
              </Box>
            </Flex>
          </ListItem>
          {identifiersFiltered.map((vehicle, index) => (
            <IdentifiersListItem
              checkboxValues={checkboxValues}
              vehicle={vehicle}
              handleSelectItem={handleSelectItem}
              key={index}
              handleCreateInf={handleCreateInf}
              itemDropdownId={this.state.itemDropdownId}
              isItemDropdownOpen={this.state.isItemDropdownOpen}
              handleItemDropdown={this.handleItemDropdown}
              itemStatus={itemStatus}
              isPartner={isPartner}
              changeTagIdentifiers={this.changeTagIdentifiers}
              idConta={idConta}
            />
          ))}
        </ListContainer>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/IdentifiersList/index.js